export enum ReferenceImageSize {
    Thumbnail,
    Small,
    Original,
}

export class ReferenceImage {
    public id: number = 0;
    public isPrincipal: boolean = false;
    public size?: ReferenceImageSize;
    public url: string = '';

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): ReferenceImage {
        const image: ReferenceImage = new ReferenceImage();

        image.id = this.id;
        image.isPrincipal = this.isPrincipal;
        image.size = this.size;
        image.url = this.url;

        return image;
    }
}
